import React from 'react'
import { FormRenderProps } from 'react-final-form'
import checkPermission from '../../../../../../utilities/checkPermission'
import * as memoMessageType from './resultOfConsiderType'
import _ from 'lodash'
import { RoutePath } from '../../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useTranslate from '../../../../../../i18n/useTranslate'
import useWebService from '../../../../../../services/web/useWebService'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import { InitialRichTextEditorType } from '../../../../../../control/richTextEditor/richTextEditor'
import { memorandumTopic } from '../../../../../../constants/constants'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'
import useAppAlertMessageAction from '../../../../../../stores/appAlertMessage/appAlertMessageAction'
import constConsiderType from '../../../../../../constants/considerType'
import { ResultTerminateMemoMessageResponse } from '../../../../../../services/web/types/responseWebServiceTypes'

const useMemomessageTerminate = (props: memoMessageType.UseMemoMessageType) => {
    const {} = props
    const appAlertMessageAction = useAppAlertMessageAction()
    const callWebService = useWebService()
    const checkPermissionHook = checkPermission()
    const history = useHistory()
    const translate = useTranslate()
    const manageProjectStore = useManageProjectStore()
    const projectData = manageProjectStore.projectData

    const [initialValues, setInitialValues] = React.useState<any>({})
    const [required, setRequired] = React.useState<boolean>(true)

    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const formRef = React.useRef<FormRenderProps>()
    const callLookup = useLookupService()
    const [terminateCauseList, setTerminateCause] = React.useState<{ id: number; name_th: string; name_en: string }[]>(
        [],
    )
    const [isCheckedOther, setIsCheckedOther] = React.useState<boolean>(false)
    const [initialCommentCommitee, setInitialCommentCommitee] = React.useState<InitialRichTextEditorType>()
    const [initialMemoMessagePaper, setInitialMemoMessagePaper] = React.useState<{
        TH: InitialRichTextEditorType
        EN: InitialRichTextEditorType
    }>()
    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()

    React.useEffect(() => {
        if (projectData) {
            createInitialData()
        }

        if (projectData?.considerInfo && projectData?.considerInfo?.value) {
            setRequired(projectData?.considerInfo?.value === constConsiderType.exempt ? false : true)
        }

        // }, [JSON.stringify(projectData)])
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null, projectData?.considerInfo ?? null])

    React.useEffect(() => {
        getLutTerminateProjectCause()
    }, [translate.languageStore.currentLanguage])

    const getLutTerminateProjectCause = async () => {
        const res = await callLookup.getTerminateCause(1, 8)
        setTerminateCause(res.result)
    }
    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const createInitialData = async () => {
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null

        if (submittedID) {
            const res = await callWebService.getProjectTerminateMemoMessage(submittedID)
            const result = res.result
            const initialData = {
                memoMessageDate: result.memoMessageCommentDate ? new Date(result.memoMessageCommentDate) : new Date(),
                terminateCause: {
                    childSelected: [],
                    parentSelected: result.causeInfo,
                },
                terminateCauseOther: result.causeRemark,
                approveStatus:
                    result && result?.approveStatusInfo
                        ? {
                              label:
                                  translate.languageStore.currentLanguage === translate.languageKey.th
                                      ? result.approveStatusInfo.nameTH
                                      : result.approveStatusInfo.nameEN,
                              value: result?.approveStatusInfo.value.toString(),
                          }
                        : null,
            }

            const initialCommentCommittee = createInitialSuggestion(result)

            const initialMemoMessagePaper = {
                TH: {
                    contentHtml: result?.memoMessagePaper_th_html,
                    contentText: result?.memoMessagePaper_th,
                },
                EN: {
                    contentHtml: result?.memoMessagePaper_en_html,
                    contentText: result?.memoMessagePaper_en,
                },
            }
            const initialMemorandumFile = createInitialFileMemorandum(result.memoMessagePaperInfo)

            setInitialCommentCommitee(initialCommentCommittee)
            setInitialMemoMessagePaper(initialMemoMessagePaper)
            setInitialMemorandumFile(initialMemorandumFile)
            setInitialValues(initialData)
        }
    }

    /**
     * createInitial
     */
    const createInitialSuggestion = (content?: ResultTerminateMemoMessageResponse) => {
        const initialSugestionNotice = {
            contentHtml: content?.memoMessageComment_html ?? '',
            contentText: content?.memoMessageComment ?? '',
        }

        return initialSugestionNotice
    }

    const createInitialFileMemorandum = (memorandumInfo: any) => {
        const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                if (memorandumInfo?.name_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: memorandumInfo?.name_th,
                        filename: memorandumInfo?.name_th,
                        fileID: memorandumInfo?.name_th,
                        path: memorandumInfo?.signPathInfo?.path_th,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                if (memorandumInfo?.name_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: memorandumInfo?.name_en,
                        filename: memorandumInfo?.name_en,
                        fileID: memorandumInfo?.name_en,
                        path: memorandumInfo?.signPathInfo?.path_en,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            }

            itm.uploadFileObj.subTopicPageList = []
        })
        return uploadFileMemoranduminit
    }

    /**
     * process click button
     */

    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    const handleClickOpenFile = async (url: string) => {
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.open('GET', url, true) // false for synchronous request
        xmlHttp.onreadystatechange = function () {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                var status = xmlHttp.status
                if (status === 0 || (status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    window.open(url)
                } else {
                    // Oh no! There has been an error with the request!
                    appAlertMessageAction.openAlertMessage({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        message: translate.get('MESSAGE.M011'),
                    })
                }
            }
        }
        xmlHttp.send()
    }

    return {
        formRef,
        configDialog,
        isViewMode: isViewMode,
        initialValues,
        initialCommentCommitee,
        initialMemoMessagePaper,
        initialMemorandumFile,
        terminateCauseList,
        required,
        isCheckedOther,
        onRefDialog,
        onClickBackToSearch: handleClickBackToSearch,
        onClickOpenFile: handleClickOpenFile,
    }
}

export default useMemomessageTerminate
